export const raisinDistributorRegflows = ['bonuscode'];
//# sourceMappingURL=distributors.js.map